export class ReportFilterDto {
  dateName: string = '';
  date: string = '';
  type: Array<string> = [];
}